import { legislationReviewPolicyProvider } from './legislation-review-policy-provider'
import { substanceDeclarationStrategyRegistry } from './substance-declaration-strategy-registry'

const createSubstanceDeclarationPolicyEvaluator = ({
    policyProvider = legislationReviewPolicyProvider,
    strategyRegistry = substanceDeclarationStrategyRegistry,
} = {}) => Object.freeze({
    evaluate(input = {}) {
        const resolved = policyProvider.resolveSubstanceDeclaration(input.legislation || {})

        return {
            policySource: resolved.source,
            ...strategyRegistry.evaluate({
                ...input,
                policy: resolved.policy,
            }),
        }
    },
})

const substanceDeclarationPolicyEvaluator = createSubstanceDeclarationPolicyEvaluator()

export {
    createSubstanceDeclarationPolicyEvaluator,
    substanceDeclarationPolicyEvaluator,
}

export default substanceDeclarationPolicyEvaluator
